import { motion } from 'framer-motion'
import ProductCard from '../components/ProductCard.jsx'
import { SectionWrapper, Button } from '../components/primitives/index.js'
import { useProducts } from '../context/ProductsContext.jsx'
import './FeaturedProducts.css'

const DEFAULTS = {
  eyebrow: 'Top Rated',
  heading: 'Best Sellers',
  body: 'The compounds researchers reach for again and again — proven purity, consistent potency, always in stock.',
}

export default function FeaturedProducts() {
  const { getFeaturedProducts, siteContent } = useProducts()
  const products = getFeaturedProducts()
  const c = { ...DEFAULTS, ...(siteContent?.featuredProducts ?? {}) }

  return (
    <SectionWrapper id="best-sellers" className="featured container">
      <div className="featured__header">
        <div className="featured__heading">
          <span className="featured__eyebrow">{c.eyebrow}</span>
          <h2>{c.heading}</h2>
          <p>{c.body}</p>
        </div>
        <Button to="/catalog" variant="ghost" className="featured__view-all">
          View All &rarr;
        </Button>
      </div>

      <motion.div
        className="featured__grid"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-10%' }}
        variants={{ visible: { transition: { staggerChildren: 0.08 } } }}
      >
        {products.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </motion.div>
    </SectionWrapper>
  )
}
